(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/start.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/start.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.Start = Marionette.View.extend({
    template: function(data) {
      return svs.grassroots.templates.start_page(data);
    },
    templateContext: function() {
      return {
        footerLinks: svs.content.footer && svs.content.footer.data && svs.content.footer.data.config ? svs.content.footer.data.config : false,
        isCorporateSite: svs.grassroots.data && svs.grassroots.data.config && svs.grassroots.data.config.isCorporateSite ? svs.grassroots.data.config.isCorporateSite : false
      };
    },
    regions: {
      start_page: '#start-page'
    },
    events: {},
    initialize: function() {
      this.model = svs.grassroots.models.my_receivers;
      this.collection = svs.grassroots.collections.grassroots;
    },
    onAttach: function() {
      this.showStartPageComponent();
    },
    showStartPageComponent: function() {
      var options = {
        generalSettings: {
          branding: 'grasroten'
        },
        tabRegion: new Backbone.Model({
          items:
            svs.grassroots.data.config &&
            svs.grassroots.data.config.startPageConfig ?
              svs.grassroots.data.config.startPageConfig.tabs :
              null,
          buttons: [
            {
              label: 'Upp',
              inverted: true
            }
          ]
        }),
        footerRegion: {
          buttons:
            svs.grassroots.data.config &&
            svs.grassroots.data.config.startPageConfig ?
              new Backbone.Collection(svs.grassroots.data.config.startPageConfig.links) :
              null
        }
      };

      var overview = new svs.grassroots.views.CardsNav();
      options.promoRegion = { customView: overview };

      this.showChildView(
        'start_page',
        new svs.app.productStartPage.ProductStartPage(options)
      );
    }
  });
})(Backbone, _, svs);


 })(window);